// NOTE: This string MUST match UNSPECIFIED_REFERRAL_QUESTIONNAIRE_ID in
// packages/middleware/src/order/questionnaires/unspecified-referral.questionnaire.ts
export const UNSPECIFIED_REFERRAL_QUESTIONNAIRE_ID = 'unspecified-referral-requisition'

export interface UnspecifiedReferralFormState {
  referralFor: string
  majorComplaints: string
  diagnosisText: string
  specialInstructions: string
  referringDoctorComments: string
  specialtyCode: string
  specialtyLabel: string
  visitFindings: string
  indication: string
  summary: string
  providerSignatureDataUrl: string
  providerSignatureDate: string
}

export function createInitialUnspecifiedReferralFormState(): UnspecifiedReferralFormState {
  return {
    referralFor: '',
    majorComplaints: '',
    diagnosisText: '',
    specialInstructions: '',
    referringDoctorComments: '',
    specialtyCode: '',
    specialtyLabel: '',
    visitFindings: '',
    indication: '',
    summary: '',
    providerSignatureDataUrl: '',
    providerSignatureDate: '',
  }
}
